export default __webpack_public_path__ + "static/media/twinCities3.45cf230d.webp";